'use client'

import { usePathname } from 'next/navigation'

export type Language = 'en' | 'fr'

export function useLanguage(): { language: Language } {
  const pathname = usePathname() ?? ''
  const language: Language = pathname.startsWith('/en') ? 'en' : 'fr'
  return { language }
}
